import React from "react";

const CartSummary = ({ cartItems, totalPrice }) => {
  return (
    <div>
      <h3>Cart Summary</h3>
      {cartItems.length > 0 ? (
        <ul className="cart-summary">
          {cartItems.map((item, index) => (
            <li key={index}>
              <span>
                {item.name} (x{item.quantity})
              </span>
              <span>${(item.price * item.quantity).toFixed(2)}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p>Your cart is empty.</p>
      )}
      <h4>Total Price: ${totalPrice}</h4>
    </div>
  );
};

export default CartSummary;
